<template>
  <div class="form-wrap">
    <div class="qa-wrap">
      <div class="question w-50">
        <patternViewer
          v-if="isPatternView"
          v-model="localPattern"
          :placeholder="$t('common.context.context_pair_form.pattern.placeholder')"
          :isNewPattern="true"
        />
        <autosize-textarea
          v-else
          v-model="localUtterance"
          :placeholder="$t('common.context.context_pair_form.utterance.placeholder')"
          :maxlength="utteranceMaxLength"
        />
      </div>
      <div class="intent--block w-50">
        <intent
          class="intent--form"
          :flows="$props.flows"
          :intent.sync="localIntent"
          :errors="$props.intentErrors"
          :isIntentEditing="true"
          :isNewIntent="true"
        />
        <!-- TODO: confirmation phrase not supported by BE & sdk for now -->
        <!--                <intent-actions-->
        <!--                    :isNewIntent="true"-->
        <!--                    :newConfirmationPhrase="!($props.intent.customData && $props.intent.customData.confirmationPhrase)" -->
        <!--                    v-on:edit-confirmation-phrase="isConfPhraseModalOpened = true"-->
        <!--                />-->
      </div>
    </div>
    <!-- TODO: Currently BE & sdk does not support confirmation phrase -->
    <!--        <confirmation-phrase-->
    <!--            :opened="isConfPhraseModalOpened"-->
    <!--            :newPhrase="!($props.intent.customData && $props.intent.customData.confirmationPhrase)"-->
    <!--            :confirmationPhrase="this.localIntent.customData.confirmationPhrase"-->
    <!--            :errors="intentErrors.confirmationPhrase"-->
    <!--            v-on:save="updateConfirmationPhrase"-->
    <!--            v-on:delete="deleteConfPhrase"-->
    <!--            v-on:close="closeConfirmationModal"-->
    <!--        />-->
  </div>
</template>

<script>
import KnowledgeBus from '@/KnowledgeBus'
import { table_limits as tableLimits } from '@/modules/limits'
import autosizeTextarea from '../autosize_textarea'
import patternViewer from '@/components/common/pattern/pattern'
import Intent from '@/components/common/intent/intent'

export default {
  components: {
    Intent,
    autosizeTextarea,
    patternViewer
  },

  created () {
    KnowledgeBus.$on('pair-form::refresh', this.refreshForm)
  },

  beforeDestroy () {
    KnowledgeBus.$off('pair-form::refresh', this.refreshForm)
  },

  props: {
    isPatternView: Boolean,
    flows: Array,
    utterance: String,
    pattern: Object,
    intentErrors: Object,
    intent: {
      type: Object,
      required: true
    }
  },

  data () {
    const defaultIntent = {
      type: 'TEXT',
      name: '',
      customData: {
        confirmationPhrase: null
      }
    }

    return {
      isIntentEditing: true,
      isConfPhraseModalOpened: false,
      defaultIntent
    }
  },

  computed: {
    utteranceMaxLength () {
      return tableLimits.utterance.max
    },

    localPattern: {
      get () {
        return this.$props.pattern
      },
      set (value) {
        this.$emit('update:pattern', value)
      }
    },

    localUtterance: {
      get () {
        return this.$props.utterance
      },
      set (value) {
        this.$emit('update:utterance', value)
      }
    },

    localIntent: {
      get () {
        return this.$props.intent
      },
      set (value) {
        this.$emit('update:intent', value)
      }
    }
  },

  methods: {
    updateConfirmationPhrase (newPhrase) {
      this.localIntent.customData.confirmationPhrase = newPhrase
      this.$emit('update:intent', this.localIntent)
      this.isConfPhraseModalOpened = false
    },

    closeConfirmationModal () {
      this.isConfPhraseModalOpened = false
    },

    deleteConfPhrase () {
      this.updateConfirmationPhrase(null)
    },

    jsonBtnHandler () {
      this.$refs['json-modal'].openModal()
    },

    refreshForm () {
      this.localUtterance = ''
      this.localIntent = { ...this.defaultIntent }
      this.$emit('reset-intent-validation')
    }
  }
}
</script>

<style lang="scss" scoped>
.form-wrap {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  background: $or-white;
  border: solid 1px $or-blue;

  .v-text {
    position: absolute;
    top: -20px;
    left: 12px;

    .text {
      margin: 0;
      font-size: 11px;
      color: $or-grey;
    }
  }

  .intent--block {
    display: flex;
  }

  .intent--form {
    width: 100%;
    overflow: scroll;
  }

  .w-80 {
    width: 80%;
  }

  .w-20 {
    width: 20%;
  }

  .qa-wrap {
    display: flex;
    width: 100%;
    max-height: 250px;

    .w-50 {
      width: 50%;
    }

    .question,
    .answer {
      padding: $sp-2;
    }

    .question {
      border-right: solid 1px $or-grey;
      overflow: auto;
    }

    .answer {
      display: flex;

      .intent-type-wrap {
        min-width: 60px;
        padding-right: $sp-2;
      }

      .intent-value-wrap {
        flex-grow: 1;
      }
    }
  }

  .btn-wrap {
    padding: $sp-2;
  }
}
</style>

<style lang="scss">
.form-wrap {
  .qa-wrap {
    .question {
      .ui-textbox {
        margin-bottom: 0;
      }
    }

    .answer {
      .ui-autocomplete {
        margin-bottom: 0;
      }

      .intent-type-wrap {
        .ui-select {
          margin-bottom: 0;
        }
      }

      .intent-value-wrap {
        .ui-autocomplete {
          flex-grow: 1;
        }
      }
    }
  }

  .context-wrap > .ui-autocomplete {
    margin-bottom: 0;
  }

  .btn-wrap > .ui-icon-button {
    border-radius: 4px;
  }
}
</style>
